import React from 'react';
import { Detail } from '../components';

const DetailPage = () => {
  return (
    <Detail />
  );
};

export default DetailPage;
